import { ActionList, Popover } from "@shopify/polaris"
import React from "react"
import { useTranslation } from "react-i18next"

import { LINK_BOOK_A_DEMO, LINK_TRACKING_WHATSAPP } from "@/consts/link"
import { CROSS_SELL_POINT_ENUM } from "@/enums/CrossSellPoint"
import { openLink } from "@/utils/redirectShopify"

interface ContactGroupProps {
  popoverActive: boolean,
  setPopoverActive: (val: boolean) => void
  children?: React.ReactNode
  hasBookDemo?: boolean
  utm?: string
  CROSS_SELL_POINT?: CROSS_SELL_POINT_ENUM
}

const ContactGroup = ({
  popoverActive,
  setPopoverActive,
  children,
  hasBookDemo,
  CROSS_SELL_POINT,
  utm = "special-offer",
}: ContactGroupProps) => {
  const { t } = useTranslation("dashboard")

  // WeChat Work ID 配置
  const WECOM_IDS = {
    default: "cawcdeed8df7777ff4",
    "T-onboarding": "cawcde72cf688c044d",
    "pp-insurance-talk": "cawcdef3f59f7e868f",
  } as const

  // 构建WeCom链接的函数
  const buildWeComUrl = (wecomID: string, channel: string) => {
    return `https://work.weixin.qq.com/ca/${wecomID}?customer_channel=${channel}`
  }

  const CrossSellAction = [
    {
      content: "WhatsApp",
      onAction: () => {
        setTimeout(() => {setPopoverActive(false)})
        const tracker = window.CrossSellTracker

        if (tracker?.redirectToWhatsApp && CROSS_SELL_POINT) {
          tracker.redirectToWhatsApp(
            CROSS_SELL_POINT,
            LINK_TRACKING_WHATSAPP,
          )
        } else {
          openLink(LINK_TRACKING_WHATSAPP)
        }
      },
    },
    {
      content: "Slack",
      onAction: () => {
        setTimeout(() => {setPopoverActive(false)})
        const tracker = window.CrossSellTracker

        if (tracker?.redirectToSlack && CROSS_SELL_POINT) {
          tracker.redirectToSlack(
            CROSS_SELL_POINT,
            `https://join.slack.com/t/parcelwill-community/shared_invite/zt-2zol5x0o6-eIat3ZbDPG1_ENuVd5LfDA?utm_source=${utm}`,
          )
        } else {
          openLink(`https://join.slack.com/t/parcelwill-community/shared_invite/zt-2zol5x0o6-eIat3ZbDPG1_ENuVd5LfDA?utm_source=${utm}`)
        }
      },
    },
    {
      content: "WeCom",
      onAction: () => {
        setTimeout(() => {setPopoverActive(false)})
        const tracker = window.CrossSellTracker
        const wecomID = WECOM_IDS[utm as keyof typeof WECOM_IDS] || WECOM_IDS.default
        const wecomUrl = buildWeComUrl(wecomID, utm)
        
        if (tracker?.redirectToWeCom && CROSS_SELL_POINT) {
          tracker.redirectToWeCom(CROSS_SELL_POINT, wecomUrl)
        } else {
          openLink(wecomUrl)
        }
      },
    },
  ]

  if (hasBookDemo) {
    CrossSellAction.unshift({
      content: "Demo",
      onAction: () => {
        setTimeout(() => {setPopoverActive(false)})
        const tracker = window.CrossSellTracker

        if (tracker?.redirectToDemo && CROSS_SELL_POINT) {
          tracker.redirectToDemo(
            CROSS_SELL_POINT,
            LINK_BOOK_A_DEMO,
          )
        } else {
          openLink(LINK_BOOK_A_DEMO)
        }
      },
    })
  }

  return <Popover
    active={popoverActive}
    activator={children ? <>{children}</> : <div>{t("ContactNow")}</div>}
    autofocusTarget="first-node"
    onClose={() => setPopoverActive(false)}
  >
    <ActionList
      actionRole="menuitem"
      items={CrossSellAction}
    />
  </Popover>
}

export { ContactGroup }
